export enum FeaturedBadgeStyle {
  Filled = 1,
  Outlined = 2,
  FilledPill = 3,
  OutlinedPill = 4,
  TextOnly = 5,
}

export enum FeaturedBadgePlacement {
  ItemInfo = 1,
  OnImage = 2,
}

export enum FeaturedBadgeAlignment {
  Start = 0,
  Center = 1,
  End = 2,
}

export const FEATURED_BADGE_ALIGNMENTS = ['start', 'center', 'end'] as const;

export type FeaturedBadgeAlignmentName =
  (typeof FEATURED_BADGE_ALIGNMENTS)[number];

export const getFeaturedBadgeAlignment = (
  alignment: number,
): FeaturedBadgeAlignmentName =>
  FEATURED_BADGE_ALIGNMENTS[alignment] ?? FEATURED_BADGE_ALIGNMENTS[0];

export const FEATURED_BADGE_STYLE_PRESETS: Record<
  FeaturedBadgeStyle,
  {
    borderRadius: number;
    borderWidth: number;
    fillOpacity: number;
    borderOpacity: number;
  }
> = {
  [FeaturedBadgeStyle.Filled]: {
    borderRadius: 4,
    borderWidth: 0,
    fillOpacity: 1,
    borderOpacity: 0,
  },
  [FeaturedBadgeStyle.Outlined]: {
    borderRadius: 4,
    borderWidth: 1,
    fillOpacity: 0,
    borderOpacity: 1,
  },
  [FeaturedBadgeStyle.FilledPill]: {
    borderRadius: 20,
    borderWidth: 0,
    fillOpacity: 1,
    borderOpacity: 0,
  },
  [FeaturedBadgeStyle.OutlinedPill]: {
    borderRadius: 20,
    borderWidth: 1,
    fillOpacity: 0,
    borderOpacity: 1,
  },
  [FeaturedBadgeStyle.TextOnly]: {
    borderRadius: 0,
    borderWidth: 0,
    fillOpacity: 0,
    borderOpacity: 0,
  },
};
